import MoodIcon from '@mui/icons-material/MoodBadRounded';

export const Terrible = ({ color }) => (
  <MoodIcon fontSize="large" sx={{ color }} />
);
